import DashboardLayout from "layout/dashboard";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AuthRoutes } from "routes/AuthRoutes";
import { DashboardRoutes } from "routes/DashboardRoutes";
import useStore from "store";
import NotFound from "./notFound";

function Pages() {
  const { userInfoStore } = useStore();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      {AuthRoutes?.map((route, index) => (
        <Route key={index} path={route?.path} element={route?.element} exact />
      ))}
      <Route path="/dashboard/*" element={<DashboardLayout />}>
        {DashboardRoutes?.map((route, index) => {
          const AppRoute = (
            <Route
              key={index}
              index={route?.path === ""}
              path={route?.path}
              element={route?.element}
              exact
            />
          );
          if (route.superuser) {
            if (userInfoStore?.is_superuser) {
              return AppRoute;
            }
          } else {
            return AppRoute;
          }
        })}
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Pages;
